import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const autocompleteWrapper: ThemedFunctor = ({
  theme,
}) => css`
  background: ${theme.color.background.neutral.default.low};
  padding: ${theme.remSize[150]};
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remRounding['2XS']};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: ${theme.remSize[200]};
  }
`;

export const previewWrapper: ThemedFunctor = () => css`
  position: relative;
  z-index: 3;
`;
